import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent, HttpResponse, HttpErrorResponse
} from '@angular/common/http';

import { Observable } from 'rxjs';
import {catchError, map, tap} from "rxjs/operators";
import {TdLoadingService} from "@covalent/core";
import {UserData} from "../globals/userData.global";
import {environment} from "../../../environments/environment";

@Injectable()
export class MakpakhttpInterceptor implements HttpInterceptor {

  token: string;


  constructor(private userData:UserData) {
  }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

      return next.handle(request).pipe(
        tap(evt => {
          if (evt instanceof HttpResponse) {
            this.token = evt.headers.get('XSRF-TOKEN');
            console.log("XSRF-TOKEN: " + this.token);
            if (this.userData.getCsrf() == (undefined || null)) {
              this.userData.setCsrf(this.token);
            }
          }
        }, (error: any) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 401) {
              // redirect to Nova Login Page
              window.location.href = `${environment.ssoLoginUrl}` + '?autologin=true&target=' + `${environment.ssoTargetKey}`;
            }
          }
        })
      );
  }
}
